import { FlexContainer, Icon, Label, Switch } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useAnonymize } from '../../providers';

export const Anonymized = () => {
  const { t } = useTranslation();
  const { anonymized, setAnonymized } = useAnonymize();

  const handleAnonymized = (value?: boolean) => {
    setAnonymized(!!value);
  };

  return (
    <FlexContainer alignItems="center" columnGap="1">
      <Icon size="24" iconName={anonymized ? 'Lock' : 'LockOpen'} />
      <Label fontSize="14" color={anonymized ? 'primary400' : 'grey700'}>
        {t(anonymized ? t('Privacy mode on') : t('Privacy mode off'))}
      </Label>
      <Switch
        id="anonymized-button"
        checked={anonymized}
        onChange={handleAnonymized}
      />
    </FlexContainer>
  );
};
